export default {
  items: [
    {
      name: 'Client',
      url: '/client',
      icon: 'icon-people'
    },
    {
      name: 'Production',
      url: '/production',
      icon: 'icon-wallet'
    },
    {
      name: 'Commandes',
      url: '/listing',
      icon: 'icon-people'
    },
    {
      name: 'Clients',
      url: '/clients',
      icon: 'icon-list'
    },
    {
      name: 'Déconnexion',
      url: '/logout',
      icon: 'icon-logout'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js